"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

//fa-plus
var Plus = function Plus() {
  return _react["default"].createElement("g", null, _react["default"].createElement("path", {
    d: "M446,230.1v51.8c0,7.2-2.5,13.3-7.6,18.4c-5,5-11.2,7.6-18.4,7.6H307.8v112.3c0,7.2-2.5,13.3-7.6,18.4c-5,5-11.2,7.6-18.4,7.6h-51.8c-7.2,0-13.3-2.5-18.4-7.6c-5-5-7.6-11.2-7.6-18.4V307.8H91.9c-7.2,0-13.3-2.5-18.4-7.6c-5-5-7.6-11.2-7.6-18.4v-51.8c0-7.2,2.5-13.3,7.6-18.4c5-5,11.2-7.6,18.4-7.6h112.3V91.9c0-7.2,2.5-13.3,7.6-18.4c5-5,11.2-7.6,18.4-7.6h51.8c7.2,0,13.3,2.5,18.4,7.6c5,5,7.6,11.2,7.6,18.4v112.3h112.3c7.2,0,13.3,2.5,18.4,7.6C443.5,216.8,446,222.9,446,230.1L446,230.1z"
  }));
};

Plus.displayName = 'Plus';
var _default = Plus;
exports["default"] = _default;
Plus.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "Plus"
};

if (typeof STORYBOOK_REACT_CLASSES !== "undefined") {
  STORYBOOK_REACT_CLASSES["src/Plus.js"] = {
    name: "Plus",
    docgenInfo: Plus.__docgenInfo,
    path: "src/Plus.js"
  };
}